export interface Rgb {
  r: number;
  g: number;
  b: number;
}
